<template>
    <reo-dialog
        class='selectProduct'
        :title="dialogTitle"
        :labelOfConfirm="$t('selectProduct.confirm')"
        isBottomWhenMobile
        use-action-footer
        :showButton="!selectProductEmpty"
        @cancel= "closeDialog"
        @confirm = "selectDevice"
        v-if="show && esimProfile"
        :confirmGaLabel="confirmGaLabel"
    >
        <div class="select-device-content">
            <select-product
                tableLoc="select"
                @selectedDevicesChange='handleDevices'
                :selectedDevices='selectedDevices'
                :deviceData='filterDevice'
                :selectLimit="planVideoQuantity"
                :availableModel="availableModels"
                :subId="subId"
                sticky-header
                @emptyStateChange="handleEmptyStateChange">
            </select-product>
        </div>
        <template #attention>
            <div v-if="changeAssociated && !selectProductEmpty" class='attention'>
                <p>{{$t('selectProduct.changeAssociated')}}</p>
            </div>
        </template>
    </reo-dialog>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import ReoDialog from '@/basic/Dialog.vue';
import SelectProduct from '@/components/selectProduct.vue';
import { ISubscribeArgs, ISubscribeArgsWithDeviceInfo, ITotalDeviceWithSubInfo } from '../lib/types';
import { getIccidByUid } from '@/api/subscriptions';
import { IEsim } from '@reolink-cloud/interface';

export default Vue.extend({
    components: {
        ReoDialog,
        SelectProduct
    },
    model: {
        prop: 'show',
        event: 'update:show'
    },
    props: {
        show: Boolean,
        deviceData: Array as PropType<ITotalDeviceWithSubInfo[]>,
        subId: String,
        subDeviceGroup: String,
        subscribeArgs: Object as PropType<ISubscribeArgs>,
        confirmGaLabel: String,
        defaultSelectedUids: {
            type: Array as PropType<string[]>,
            default: (): string[] => []
        }
    },
    data() {

        return {
            hadSelect: 0,
            selectedDevices: [] as unknown[],
            deviceOverflow: false,
            deviceGroupChange: false,
            changeAssociated: false,
            selectedDevicesURL: '',
            esimProfile:null as IEsim[]|null,
            selectProductEmpty: false
        };

    },
    computed: {
        dialogTitle(): string {

            return this.$t( 'selectProduct.title' ) + ' (' + this.hadSelect + '/' + this.planVideoQuantity + ')';

        },
        planVideoQuantity(): number {

            return this.subscribeArgs.plan.style['cloud_storage.max_device_quantity'] ?? 0;

        },
        availableModels(): string[] {

            return this.subscribeArgs.availableModels ?? [];

        },
        availableModelCount(): number {

            let availableModelCount = 0;

            for ( let device of this.filterDevice ) {

                if ( this.availableModels.includes( device.model )) {

                    availableModelCount++;

                }

            }

            return availableModelCount;

        },
        filterDevice(): ITotalDeviceWithSubInfo[] | undefined {

            return this.deviceData.filter( item => {

                const isLocked = this.esimProfile?.find( esim => esim.uid === item.uid );

                return !isLocked && item.boundStatus === 'bound';

            });

        },
    },
    watch: {
        subscribeArgs: {
            handler( newVal: ISubscribeArgs ) {

                const { series } = newVal;

                /**
                 * 更新默认选中设备
                 */
                let subDeviceList: any[] = [];
                for ( let device of this.filterDevice ) {

                    const selectedByUid = this.defaultSelectedUids.length > 0
                        && this.defaultSelectedUids.includes( device.uid );
                    const selectedBySubscription = this.defaultSelectedUids.length === 0
                        && device.subscription === this.subId
                        && ( device.status === 'associated' || device.unassociationReason === 'expired' );
                    if ( selectedByUid || selectedBySubscription ) {

                        subDeviceList.push( device );

                    }

                }
                this.selectedDevices = subDeviceList;
                this.deviceOverflow = this.selectedDevices.length > this.planVideoQuantity;
                this.deviceGroupChange = Boolean( this.subDeviceGroup ) && series.deviceGroup !== this.subDeviceGroup;

            },
            immediate: true,
        }
    },
    async created() {

        this.esimProfile = await getIccidByUid();

    },
    methods: {
        closeDialog (): void {

            this.$emit( 'update:show', false );
            this.selectedDevicesURL = '';
            this.hadSelect = 0;

        },
        selectDevice() {

            this.$emit( 'select-device', {
                ...this.subscribeArgs,
                deviceOverflow: this.deviceOverflow,
                deviceGroupChange: this.deviceGroupChange,
                selectedDevicesURL: this.selectedDevicesURL
            } as ISubscribeArgsWithDeviceInfo );
            this.$emit( 'update:show', false );

        },
        handleDevices ( newVal ): void {

            this.selectedDevicesURL = newVal.map(( item ) => JSON.stringify( item )).join( ';' );
            this.selectedDevicesURL = encodeURI( this.selectedDevicesURL );
            this.hadSelect = newVal.length;
            let changeAssociated = false;
            for ( let item of newVal ) {

                if ( item.status === 'associated' && item.subscription !== this.subId ) {

                    changeAssociated = true;

                }

            }
            this.changeAssociated = changeAssociated;

        },
        handleEmptyStateChange ( isEmpty: boolean ): void {

            this.selectProductEmpty = isEmpty;

        },
    }
});
</script>

<style lang="less" scoped>

.selectProduct{
    .select-product-dialog();
}
</style>
